export default __webpack_public_path__ + "static/media/outcess13.11874fff.jpeg";